import { Route, Routes } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";
import Login from "./pages/auth/Login";
import Dashboard from "./pages/dashboard/Dashboard";
import PersistLogin from "./hooks/PersistLogin";
import Client from "./pages/Client";
import User from "./pages/User";
import Serialization from "./pages/serialization/Serialization";
import { SidebarProvider } from "./components/ui/sidebar";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ChangePassword from "./pages/auth/ChangePassword";
import ClientProducts from "./pages/ClientProducts";
import ClientLocations from "./pages/ClientLocations";
import OnboardLocations from "./pages/onboarding/ClientLocations";
import OnboardProducts from "./pages/onboarding/ClientProducts";
import ResetPassword from "./pages/auth/ResetPassword";
import SetPassword from "./pages/auth/SetPassword";


function App() {
	return (
		<SidebarProvider>
			<Toaster />
			<Routes>
				<Route index element={<Login />} />
				<Route path="/forgot-password" element={<ForgotPassword />} />
				<Route path="/change-password" element={<ChangePassword />} />
				<Route path="/reset-password" element={<ResetPassword />} />
				<Route path="/set-password" element={<SetPassword />} />
				<Route path="/onboard-products" element={<OnboardProducts />} />
				<Route path="/onboard-locations" element={<OnboardLocations />}
				/>
				<Route element={<PersistLogin />}>
					<Route path="pages" element={<Home />}>
						<Route index element={<Dashboard />} />
						<Route path="/pages/client" element={<Client />} />
						<Route
							path="/pages/products"
							element={<ClientProducts />}
						/>
						<Route
							path="/pages/locations"
							element={<ClientLocations />}
						/>
						<Route path="/pages/user" element={<User />} />
						<Route
							path="/pages/serialization"
							element={<Serialization />}
						/>
					</Route>
				</Route>
			</Routes>
		</SidebarProvider>
	);
}

export default App;
